import { useEffect, useState, useCallback } from "react"
import GoogleMapReact from "google-map-react"
import { VenuesMapMarker } from "../map/VenuesMapMarker"

export const VenuesMap = (props) => {
  const [isDraggingMarker, setIsDraggingMarker] = useState(false)
  const [hooveredItem, setHooveredItem] = useState<any>()
  //   REACT_APP_GOOGLE_MAP_KEY=AIzaSyAodrP9bEZJwUu7RTIVgu6X7Ps5IYszvh4
  var mapKeys = { key: "AIzaSyAodrP9bEZJwUu7RTIVgu6X7Ps5IYszvh4" }
  var maps
  var mapRef // = useRef();
  var [mapRef, setMapRef] = useState(undefined)
  const center = { lat: 59.95, lng: 30.33 }
  const defaultZoom = 7

  const handleOnGoogleApiLoaded = (
    map: google.maps.Map,
    maps: { map: google.maps.Map; event: any }
  ) => {
    maps = maps
    // mapRef = map;
    setMapRef(map)
    recenter()
  }

  const recenter = useCallback(() => {
    if (!props.noRecenter) {
      const bounds = new window.google.maps.LatLngBounds()
      if (props.venues && mapRef) {
        props.venues.forEach((venue) => {
          // if (child.type === Marker) {
          if (venue.lat && venue.lng) {
            bounds.extend(new window.google.maps.LatLng(venue.lat, venue.lng))
          }
          // }
        })
        mapRef.fitBounds(bounds)
      }
    }
    // const {center, zoom} = fitBounds(bounds, size);
  }, [props.venues, mapRef, maps])

  useEffect(() => {
    if (mapRef) {
      recenter()
    }
  }, [mapRef, props.venues, maps])

  const createMapOptions = () => {
    if (!window || !window.navigator || !window.navigator.userAgent) {
      return {}
    }
    // const md = new MobileDetect(window.navigator.userAgent)
    const isMobile = false // md.mobile()
    return {
      panControl: false,
      mapTypeControl: false,
      scrollwheel: !isMobile, // Disable on mobile
      fullscreenControl: false,
      gestureHandling: "greedy",
      clickableIcons: false,
      maxZoom: 18,
      styles: [
        {
          stylers: [
            { saturation: -85 },
            { gamma: 0.95 },
            { lightness: 40 },
            { visibility: "on" },
          ],
        },
        {
          featureType: "poi",
          stylers: [{ visibility: "off" }],
        },
      ],
    }
  }
  const handleMouseOver = (venue) => {
    console.log("handleMouseOver", venue)
    setHooveredItem(venue)
    if (props.onMouseOverVenue) {
      props.onMouseOverVenue()
    }
  }

  const handleMouseLeave = () => {
    if (props.onMouseLeaveVenue) {
      props.onMouseLeaveVenue()
    }
    setHooveredItem(undefined)
  }
  console.log("map", hooveredItem, props.mapSelectedVenue)
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <GoogleMapReact
        // ref={mapRef}
        draggable={!isDraggingMarker}
        bootstrapURLKeys={mapKeys}
        onGoogleApiLoaded={({ map, maps }) =>
          handleOnGoogleApiLoaded(map, maps)
        }
        onMap
        options={createMapOptions}
        defaultCenter={center}
        // center={
        //   this.state.currentLocation ? this.state.currentLocation : this.center
        // }
        // zoom={this.state.zoom ? this.state.zoom : this.zoom}
        defaultZoom={defaultZoom}
        // onChildMouseDown={this.onCircleInteraction}
        // onChildMouseUp={this.onMarkerDragEnd}
        // onChildMouseMove={this.onCircleInteraction}
        onChildClick={(e: any) => console.log("child click", e)}
        onChange={props.onMapChange}
      >
        {props.venues &&
          props.venues.map((venue) => {
            if (!venue) {
              return <span />
            }
            return (
              <VenuesMapMarker
                onMouseOver={handleMouseOver}
                onMouseLeave={handleMouseLeave}
                onSelectVenue={props.onSelectVenue}
                lat={venue.lat}
                lng={venue.lng}
                venue={venue}
                key={venue.id}
                hoovered={hooveredItem?.id === venue.id}
                selected={
                  props.mapSelectedVenue &&
                  props.mapSelectedVenue.id === venue.id
                }
              />
            )
          })}
      </GoogleMapReact>
    </div>
  )
}
